<template>
  <div class="users" @keyup.13="submit">
    <mu-dialog
      title="查看用户"
      width="500"
      :open="open"
      @close="close"
      class="users-dialog"
    >
      <div v-for="(item, index) in userList" :key="index">
        <mu-checkbox
          v-model="item.checked"
          :label="item.realName"
        ></mu-checkbox>
      </div>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    permission: {
      type: Object
    }
  },
  data() {
    return {
      userList: []
    }
  },
  methods: {
    submit() {
      const permission = JSON.parse(JSON.stringify(this.permission))
      permission.users = this.userList.filter((x) => x.checked)
      backend(api.permission.update, permission).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllUser() {
      this.userList = []
      backend(api.user.getAll, { getAll: true, isClerk: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            const userList = result.data.rows
            userList.forEach((item) => {
              if (this.permission.users.some((x) => x.id === item.id)) {
                item.checked = true
              } else {
                item.checked = false
              }
            })
            this.userList = userList
          }
        }
      )
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.getAllUser()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.users-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/permission/users.vue